module.exports = __webpack_public_path__ + "img/KB Bukopin Syariah.f7a1abce.png";